import type { RoteirizacaoModel } from "../models/roteirizacaoModel"
import { RoteirizacaoActionsTypes, type RoteirizacaoAction } from "./roteirizacaoActions"

export function roteirizacaoReducer(
    state: RoteirizacaoModel,
    action: RoteirizacaoAction
): RoteirizacaoModel {
    switch (action.type) {
        case RoteirizacaoActionsTypes.CARREGAR_DADOS:
            return {
                ...state,
                pedidos: action.payload.pedidos,
                entregadores: action.payload.entregadores,
                pedidosSelecionados: [],
            }

        case RoteirizacaoActionsTypes.SET_DATA:
            return { ...state, data: action.payload }

        case RoteirizacaoActionsTypes.SET_FILTRO_STATUS:
            return { ...state, filtroStatus: action.payload }

        case RoteirizacaoActionsTypes.SET_ENTREGADOR:
            return { ...state, entregadorSelecionadoId: action.payload }

        case RoteirizacaoActionsTypes.TOGGLE_PEDIDO: {
            const jaMarcado = state.pedidosSelecionados.includes(action.payload)
            return {
                ...state,
                pedidosSelecionados: jaMarcado
                    ? state.pedidosSelecionados.filter(id => id !== action.payload)
                    : [...state.pedidosSelecionados, action.payload],
            }
        }

        case RoteirizacaoActionsTypes.SELECIONAR_IDS:
            return { ...state, pedidosSelecionados: action.payload }

        case RoteirizacaoActionsTypes.LIMPAR_SELECAO:
            return { ...state, pedidosSelecionados: [] }

        case RoteirizacaoActionsTypes.SET_USO:
            return {
                ...state,
                usados: action.payload.usados,
                limite: action.payload.limite,
                ilimitado: action.payload.ilimitado,
                idParametroContador: action.payload.idParametroContador,
            }

        case RoteirizacaoActionsTypes.APLICAR_ASSOCIACAO: {
            const idsAssociados = new Set(action.payload.ids)
            return {
                ...state,
                pedidos: state.pedidos.map(p =>
                    idsAssociados.has(p.id)
                        ? { ...p, motoboyPedido: action.payload.nomeEntregador }
                        : p
                ),
                pedidosSelecionados: [],
                usados: action.payload.usados,
                idParametroContador: action.payload.idParametroContador,
            }
        }

        default:
            return state
    }
}
